import { cn } from './cn';

export type PillTone =
  | 'slate'
  | 'blue'
  | 'indigo'
  | 'violet'
  | 'purple'
  | 'sky'
  | 'cyan'
  | 'teal'
  | 'emerald'
  | 'green'
  | 'lime'
  | 'amber'
  | 'orange'
  | 'red'
  | 'rose'
  | 'pink'
  | 'fuchsia'
  | 'zinc'
  | 'stone';

export type PillSize = 'xs' | 'sm' | 'md';

const PILL_BASE =
  'inline-flex min-w-fit items-center justify-center whitespace-nowrap rounded-full border font-semibold leading-none shadow-none transition-colors';

const PILL_SIZES: Record<PillSize, string> = {
  xs: 'min-h-[19px] px-2 py-0.5 text-[10px]',
  sm: 'min-h-[24px] px-2.5 py-0.5 text-[11px]',
  md: 'min-h-[28px] px-3 py-0.5 text-[12px]',
};

const PILL_TONES: Record<PillTone, string> = {
  slate: 'border-slate-200 bg-slate-50 text-slate-600',
  blue: 'border-blue-200 bg-blue-50 text-blue-700',
  indigo: 'border-indigo-200 bg-indigo-50 text-indigo-700',
  violet: 'border-violet-200 bg-violet-50 text-violet-700',
  purple: 'border-purple-200 bg-purple-50 text-purple-700',
  sky: 'border-sky-200 bg-sky-50 text-sky-700',
  cyan: 'border-cyan-200 bg-cyan-50 text-cyan-700',
  teal: 'border-teal-200 bg-teal-50 text-teal-700',
  emerald: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  green: 'border-green-200 bg-green-50 text-green-700',
  lime: 'border-lime-200 bg-lime-50 text-lime-700',
  amber: 'border-amber-200 bg-amber-50 text-amber-700',
  orange: 'border-orange-200 bg-orange-50 text-orange-700',
  red: 'border-red-200 bg-red-50 text-red-700',
  rose: 'border-rose-200 bg-rose-50 text-rose-700',
  pink: 'border-pink-200 bg-pink-50 text-pink-700',
  fuchsia: 'border-fuchsia-200 bg-fuchsia-50 text-fuchsia-700',
  zinc: 'border-zinc-200 bg-zinc-50 text-zinc-700',
  stone: 'border-stone-200 bg-stone-50 text-stone-700',
};

export function pillClass(tone: PillTone = 'slate', size: PillSize = 'sm', className?: string) {
  return cn(PILL_BASE, PILL_SIZES[size], PILL_TONES[tone], className);
}
